import { MutationTree } from 'vuex'
import { SubscriptionState } from './types'
import Subscription from '@/calendesk/models/DTO/Response/Subscription'

export const mutations: MutationTree<SubscriptionState> = {
  SET_SUBSCRIPTIONS (state, payload: Subscription[]) {
    state.subscriptions = payload
  }
}
